export default {
  clientIp: state => state.clientIp,
  currentStep: state => state.currentStep,
  url: state => state.url,
  competitors: state => state.competitors,
  competitorErrors: state => state.competitorErrors,
  error: state => state.error,
}
